import { Tabs, Tab } from "@mui/material"
import StepperContentContainer from "../StepperContentContainer"
import { useContext, useState } from "react"
import Configurations from "./Configurations"
import { KickOffContext } from "@/Contexts/KickOff"
import ProjectActivities from "../../ProjectActivities"

const ProjectDetails: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState('configurations');
  const { activities, setActivities } = useContext(KickOffContext);

  return (
    <StepperContentContainer>
      <Tabs
        value={selectedTab}
        onChange={(_, newSelection) => setSelectedTab(newSelection)}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
      >
        <Tab value="activities" label="Activities" />
        <Tab value="configurations" label="Configurations" />
      </Tabs>

      {selectedTab === 'activities' && <ProjectActivities activities={activities} setActivities={setActivities} />}
      {selectedTab === 'configurations' && <Configurations />}
    </StepperContentContainer>
  )
}

export default ProjectDetails;
